import type { VoidFunctionComponent } from 'react';

import { OIDCProviderScope } from '../../../../../shared/model-typings/oidcprovider';
import type { OIDCListTrustRelationshipsResponse } from '../../../../../shared/types/routes/oidc';

import styles from './DetailsDrawer.module.less';

type TrustRelationshipDetailsDrawerProps = {
  trustRelationship: OIDCListTrustRelationshipsResponse;
};

const TrustRelationshipDetailsDrawer: VoidFunctionComponent<TrustRelationshipDetailsDrawerProps> = ({
  trustRelationship,
}) => {
  return (
    <div>
      <h2 className={styles.title}>Trust Relationship Details</h2>

      {/* User Information Section */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Service Account Information</h3>

        <div className={styles.fieldRow}>
          <div className={styles.field}>
            <span className={styles.label}>Username</span>
            <div className={styles.value}>{trustRelationship.username}</div>
          </div>
          {trustRelationship.email && (
            <div className={styles.field}>
              <span className={styles.label}>Email</span>
              <div className={styles.value}>{trustRelationship.email}</div>
            </div>
          )}
        </div>
      </div>

      {/* Provider Information Section */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Provider Information</h3>

        <div className={styles.field}>
          <span className={styles.label}>Issuer</span>
          <div className={styles.value}>{trustRelationship.issuer}</div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Provider ID</span>
          <div className={styles.value}>{trustRelationship.providerId}</div>
        </div>
      </div>

      {/* OIDC Configuration Section */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>OIDC Configuration</h3>

        <div className={styles.field}>
          <span className={styles.label}>Audiences</span>
          <div className={styles.value}>
            {trustRelationship.audiences.length > 0
              ? trustRelationship.audiences.join(', ')
              : 'None'}
          </div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Required Claims</span>
          <div className={styles.value}>
            {trustRelationship.requiredClaims.length > 0 ? (
              <ul className={styles.list}>
                {trustRelationship.requiredClaims.map(({ claim, value, hasWildcards }) => (
                  <li key={claim}>
                    <strong>{claim}</strong>: {String(value)}
                    {hasWildcards && ' (wildcards enabled)'}
                  </li>
                ))}
              </ul>
            ) : (
              'None'
            )}
          </div>
        </div>
      </div>

      {/* Access Control Section */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Access Control</h3>

        <div className={styles.fieldRow}>
          <div className={styles.field}>
            <span className={styles.label}>Scope</span>
            <div className={styles.value}>
              {trustRelationship.scope === OIDCProviderScope.ORG ? 'Organization' : 'Team'}
            </div>
          </div>

          {trustRelationship.scope === OIDCProviderScope.TEAM && trustRelationship.teamName && (
            <div className={styles.field}>
              <span className={styles.label}>Team Name</span>
              <div className={styles.value}>{trustRelationship.teamName}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrustRelationshipDetailsDrawer;
